module.exports = __webpack_public_path__ + "img/logo-light.87e502ed.png";